export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-row/index.js